// extracted by mini-css-extract-plugin
export var card = "_ps-0";
export var content = "_ps-2";
export var details = "_ps-3";
export var icon = "_ps-1";
export var iconBlue = "_ps-5";
export var iconBrand = "_ps-4";
export var iconGrayBlue = "_ps-6";
export var iconGreen = "_ps-7";
export var iconIndigo = "_ps-8";
export var iconOrange = "_ps-9";
export var iconPurple = "_ps-a";
export var iconRed = "_ps-b";
export var iconWarning = "_ps-c";